import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Grid, Typography } from "@mui/material";
import ItemsList from "../../../components/ItemsList/ItemsList";
import "./Statistic.scss";
import { totalValue } from "../Board";
import { getStatistic } from "../../../request/user";
import ReloadIcon from "../../../components/ReloadIcon/ReloadIcon";
import { Link } from "react-router-dom";

export default memo(function Statistic() {
  const [elements, setElements] = useState(null);
  const [total, setTotal] = useState(null);

  const [showReloadIcon, setShowReloadIcon] = useState(false);
  useEffect(() => {
    const get = async () => {
      await reload();
    };
    get().catch((err) => console.error(err));

    const intervalCall = setInterval(async () => {
      await reload();
    }, 60000 * 5);
    return () => {
      // clean up
      clearInterval(intervalCall);
    };
  }, []);

  const reload = async () => {
    setShowReloadIcon(false);
    await setTimeout(() => {
      getData();
    }, 10);
  };

  const getData = useCallback(async () => {
    try {
      const res = await getStatistic();
      setElements(format(res?.data?.data));
      setShowReloadIcon(true);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const tableHeaders = useMemo(() => {
    return [
      {
        field: "assignee",
        headerName: "Assignee",
        sortable: false,
        type: "string",
        maxWidth: 200,
        flex: 1,
        renderCell: (item) => (
          <div className="nowrap">
            <Link to={`/user?id=${item.row?.user?.id}`}>
              {item.row?.user?.name}
            </Link>
          </div>
        ),
      },
      {
        field: "all",
        headerName: "All",
        flex: 1,
        type: "number",
        renderCell: (item) => <span>{parseInt(item.value)}</span>,
      },
      {
        field: "days_5",
        headerName: ">5 days",
        flex: 1,
        type: "number",
        renderCell: (item) => <span>{parseInt(item.value)}</span>,
      },
      {
        field: "days_7",
        headerName: ">7 days",
        flex: 1,
        type: "number",
        renderCell: (item) => <span>{parseInt(item.value)}</span>,
      },
    ];
  }, []);

  const format = useCallback((items) => {
    if (!items) return;
    let arr = items
      .map((el) => {
        el.id = el.id ?? el.user_id;
        el.all = el.summary?.total ?? 0;
        el.days_5 = el.summary?.opened_over_5_days;
        el.days_7 = el.summary?.opened_over_7_days;
        return el;
      })
      .filter((el) => el.days_5 > -1);

    // const sorterDesc = (sortBy) => (a, b) => a[sortBy] > b[sortBy] ? -1 : 1;
    // arr.sort(sorterDesc("all"));

    return arr;
  }, []);

  useEffect(() => {
    if (elements !== null) {
      const totalAll = totalValue(elements, "all");
      const totalDays5 = totalValue(elements, "days_5");
      const totalDays7 = totalValue(elements, "days_7");

      setTotal({ all: totalAll, days_5: totalDays5, days_7: totalDays7 });
    }
  }, [elements]);

  return (
    <div className="block-inner">
      <div className="mb-15">
        <div className="flex mb-15">
          <div>
            <Typography variant="h6">Statistic</Typography>
          </div>
          <div className="pl-15">
            {!!showReloadIcon && (
              <div
                className="reload-btn"
                title="Reload"
                onClick={() => {
                  reload();
                }}
              >
                {" "}
                <ReloadIcon timeout={60 * 5} />
              </div>
            )}
          </div>
        </div>
      </div>
      {elements && (
        <>
          <ItemsList
            items={elements}
            headers={tableHeaders}
            defaultPageSize={elements.length}
            totalCount={elements.length}
            gridId="statistic-grid"
            defaultSortModel={{ field: "all", sort: "desc" }}
          />
          {!!total && (
            <Grid
              className="total-bottom"
              container
              style={{ textAlign: "right" }}
            >
              <Grid item xs={3} style={{ textAlign: "left" }}>
                Total
              </Grid>
              <Grid item xs={3}>
                {total.all}
              </Grid>
              <Grid item xs={3}>
                {total.days_5}
              </Grid>
              <Grid item xs={3}>
                {total.days_7}
              </Grid>
            </Grid>
          )}
        </>
      )}
    </div>
  );
});
